import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { createPortal } from 'react-dom';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ConditionalLink, Component, Popup, Modal, UniversalLink, Icon, Toast } from '@plone/volto/components';
import { getBaseUrl, flattenToAppURL, getContentIcon } from '@plone/volto/helpers';
import { toast } from 'react-toastify';
import infoSVG from '@plone/volto/icons/info.svg';
import { Container, Image, Button, Header, List, ListItem, Table } from 'semantic-ui-react';
import { DebounceInput } from 'react-debounce-input';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { getContent } from '@plone/volto/actions';
import { getSilencer } from '../../../../../actions';
import { useSessionStorage } from '../../../../../helpers';
import { SelectionTable, SelectionStorage } from '../../../../../selection/table';
import { GeneratePdfForm } from '../../../../../selection/document';
import { Acoustic, AcousticFrequencies } from '../../../../../selection/acoustic';
import { ShowMore } from '../../../../../selection/listcontent';
import { RelatedItems, ContentLink } from '../../../../../selection/relateditems';
import { ShowMultiSilencer, VariantTable } from '../../../../../selection/variant';
import { trackEvent } from '@eeacms/volto-matomo/utils';
import { isEqual } from 'lodash';
import { startCase } from 'lodash';
import { v4 as uuid } from 'uuid';
import moment from 'moment';

class NameForm extends React.Component {
    constructor(props) {
      super(props);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleInputSubmit = this.handleInputSubmit.bind(this);
    }

    handleInputChange(event) {    
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.props.setPerformance(
            {
             ...this.props.performance,
             [name]: value
            }
        );
    }

    handleSelectChange(name, data) {    
        const value = data.value;
        trackEvent({category: 'performance', action: "silencer", name: name, value: value});
        this.props.setPerformance(
            {
             ...this.props.performance,
             [name]: value
            }
        );
    }

    handleInputSubmit(event) {
        const options = {category: 'calculate', action: Object.entries(this.props.performance).filter(item => item[1]).map(item => item.join('=')).join(' ')};
        trackEvent(options); 
        event.preventDefault();
    }
    frequencies(title, field_name, delay ){
        return (
            <>
            <h5 className="form_line fullwidth">{ title }</h5>
            <div className="form_line inline">
                { this.props.frequencies.map(frequency => ( 
                    <label key={field_name + '_' + frequency}>
                        {frequency}
                        <DebounceInput
                            debounceTimeout={delay} type="number" name={field_name + '_' + frequency}
                            value={this.props.performance[field_name + '_' + frequency] || ''}
                            onChange={this.handleInputChange} />dB
                    </label>
                ))}
            </div>
            </>)
    }

    select_lookup(selection, field_name){
        return selection.filter(item => (item['value'] === this.props.performance[field_name]));
    }

    render() {
        const searchParams = new URLSearchParams(document.location.search);
        const query = searchParams.get('query');
        let query_options = [];
        if (query){
            const geometry = JSON.parse(query).filter(item => (item['i'] === 'Subject_Silencer_Geometry')).map(data => data['v']);
            if (geometry.length == 1){
                query_options = geometry[0].map(value => value.toLowerCase());
            }
        }
        const protection = [
            {'label' : 'Fibreglass – No Media Protection',
             'value': ''},
            {'label': 'Fibreglass - Fibreglass Cloth (scrim) Media Protection',
             'value': 'fibreglass'},
            {'label': 'Fibreglass - Polymer Film Media Protection',
             'value': 'polymer'},
            {'label': 'No Insulation - No Media Protection',
             'value': 'packless'},
        ]

        const casing = [
            {'label': 'Standard',
             'value': 'STD'},
            {'label': 'Extended',
             'value': 'EXTD'},
        ]

        const performance = [
            {'label': 'Insertion Loss',
             'value': 'insertion'},
            {'label': 'Design Criteria',
             'value': 'criteria'},
        ]
        const criteria = [
            {'label': 'NC',
             'value': 'NC'},
            {'label': 'RC',
             'value': 'RC'},
            {'label': 'dBA',
             'value': 'dBa'},
        ]
        const direction = [
            {'label': 'Forward/Supply',
             'value': 'F'},
            {'label': 'Return/Intake',
             'value': 'R'},
        ]
        const inlet_condition = [
            {'label': 'Ideal',
             'value': 'I'},
            {'label': 'Smooth Inlet',
             'value': 'SM'},
            {'label': 'Sharp Inlet',
             'value': 'SH'},
            {'label': 'Mitre Elbow',
             'value': 'ME'},
            {'label': 'Elbow with Vanes',
             'value': 'EWV'},
            {'label': 'Elbow without Vanes',
             'value': 'EWOV'},
            {'label': 'Fan',
             'value': 'F'},
        ]

        const outlet_condition = [
            {'label': 'Ideal',
             'value': 'I'},
            {'label': 'Mitre Elbow',
             'value': 'ME'},
            {'label': 'Elbow with Vanes',
             'value': 'EWV'},
            {'label': 'Elbow without Vanes',
             'value': 'EWOV'},
            {'label': 'Duct Doubling',
             'value': 'DD'},
            {'label': 'Abrupt Plenum',
             'value': 'AP'},
            {'label': 'Fan',
             'value': 'F'},
        ]
        const delay = 1000;
            
        return (
            <form className="calculator boxcode" onSubmit={this.handleInputSubmit}>       
                 
                <div className="select_box three">
                    <Popup 
                        trigger={<h5 className="info">Insulation Type <Icon className="infoicon" name={infoSVG} size="20px" /></h5>} >
                        <p>For most applications <em>‘Fibreglass – No Media Protection’</em> is appropriate.</p>
                        <p>For critical spaces such as Hospitals, Clean Rooms, and Laboratories 
                            <em>‘Fibreglass – Polymer Film Media Protection’</em> or
                            <em>‘No Insulation – No Media Protection’</em> options are recommended.</p>
                        <p>For high air velocity applications <em>‘Fibreglass – 
                            Fibreglass Cloth (scrim) Media Protection’</em> is recommended.</p>
                    </Popup>
                <Select className='protection'
                        key='protection'
                        name="protection"
                        options={ protection }
                        onChange={ (item) => this.handleSelectChange('protection', item) }
                        defaultValue={ this.select_lookup(protection, 'protection') }
                        menuPlacement="auto"
                  />
                </div>

                <div className="select_box three">
                    <Popup className="info"
                        trigger={<h5 className="info">Casing <Icon className="infoicon" name={infoSVG} size="20px" /></h5>} >
                        <p>Standard casing is typically always appropriate, however extended casing can be used when
                            performance is not attainable using standard media/fibreglass thickness.</p></Popup>

                <Select className='casing'
                        key='casing'
                        name="Casing"
                        options={ casing }
                        onChange={ (item) => this.handleSelectChange('casing', item) }
                        defaultValue={ this.select_lookup(casing, 'casing') }
                        menuPlacement="auto"
                  />
                </div>
                <div className="select_box three">
                    <Popup className="info"
                        trigger={<h5 className="info">Performance <Icon className="infoicon" name={infoSVG} size="20px" /></h5>} >
                        <p>Directly affects the criteria for selection from either known insertion loss requirements,
                            or the design criteria to achieve the required NC / RC / dBA from unsilenced noise levels.</p></Popup>
                <Select className='performance'
                        key='performance'
                        name="performance"
                        options={ performance }
                        onChange={ (item) => this.handleSelectChange('performance', item) }
                        defaultValue={ this.select_lookup(performance, 'performance') }
                        menuPlacement="auto"
                  />
                </div>
                
                { Object.entries(this.props.geometries).flatMap(
                    ([key, values]) => {
                        if (!query_options.length |
                            (query_options.includes(key) &&
                            !(key === 'elbow' && query_options.includes('circular') ))){ 
                            return (
                                <div key={'geometry_' + key} className={ 'geometry_' + key  + ' radiusbox' }>
                                  <Popup className="info" content={ 
                                    (key === 'circular' && query_options.includes('elbow')) ? 
                                    <img className="geometryimage" src={flattenToAppURL('/homepage-icons/circular_elbow.png/@@images/image/preview')} alt={ key } /> :
                                    <img className="geometryimage" src={flattenToAppURL('/homepage-icons/' + key + '.png/@@images/image/preview')} alt={ key } />
                                    }
                                  trigger={
                                  <h5 className="form_line boxheading">
                                    Geometry - { (key == 'circular') ? (startCase(key) + ' and Elbow Circular') : (startCase(key)) }
                                    <Icon className="infoicon" name={infoSVG} size="20px" />
                                  </h5>} />
                                    <Table className="boxdisplay">
                                      <Table.Body>
                                    { values.map(value => {
                                       const name = key + '_' + value;
                                       return (
                                           <Table.Row key={name}>
                                             <Table.Cell key="dimension">
                                               <label key={ name } htmlFor={ key + '_' + value }>
                                                   { startCase(value) + (value === 'diameter' ? ' (ID)' : '') }:</label>
                                             </Table.Cell>
                                             <Table.Cell key="value">
                                           <DebounceInput className="geometry_input" 
                                               id={ key + '_' + value }
                                               debounceTimeout={delay} type="number"
                                               name={ key + '_' + value }
                                               value={this.props.performance[name] }
                                               onChange={this.handleInputChange} />
                                             </Table.Cell>
                                             <Table.Cell key="units">
                                               mm
                                             </Table.Cell>
                                           </Table.Row>)
                                          })}
                                    </Table.Body>
                                  </Table>
                                </div>)
                        }
                    }
                )}

                <div className="form_line three">
                <h5>Flow Requirements</h5>
                <Table className="boxflow">
                   <Table.Body>
                    <Table.Row key="volume">
                      <Table.Cell key="dimension">
                        <label key="volume" htmlFor="volume">Airflow:</label>
                      </Table.Cell>
                      <Table.Cell key="value">
                        <DebounceInput id="volume" debounceTimeout={delay} type="number" name="volume" value={this.props.performance.volume || ''} onChange={this.handleInputChange} />
                      </Table.Cell>
                      <Table.Cell key="units">
                          l/s
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row key="pressure">
                      <Table.Cell key="dimension">
                    <label key="pressure" htmlFor="pressure">Maximum Pressure:</label>
                      </Table.Cell>
                      <Table.Cell key="value">
                    <DebounceInput id="pressure" debounceTimeout={delay} type="number" name="pressure" value={this.props.performance.pressure || ''} onChange={this.handleInputChange} />
                      </Table.Cell>
                      <Table.Cell key="units">
                          Pa (max)
                      </Table.Cell>
                    </Table.Row>

                { (this.props.performance.performance === 'criteria') && (
                    <Table.Row key="target">
                      <Table.Cell key="dimension">
                        <label key="target" htmlFor="target">Target Criteria:</label>
                      </Table.Cell>
                      <Table.Cell key="value">
                        <DebounceInput
                            id="target"
                            debounceTimeout={delay}
                            type="number"
                            name="target"
                            value={this.props.performance.target || ''}
                            onChange={this.handleInputChange} />
                      </Table.Cell>
                      <Table.Cell key="units">
                        <Select className='criteria'
                                key='criteria'
                                name="criteria"
                                options={ criteria }
                                onChange={ (item) => this.handleSelectChange('criteria', item) }
                                defaultValue={ this.select_lookup(criteria, 'criteria') }
                                menuPlacement="auto"
                          />
                      </Table.Cell>
                    </Table.Row>
                    )}
                    </Table.Body>
                  </Table>
                </div>


                <div className="select_box three">
                    <Popup 
                        trigger={<h5 className="info">Airflow Direction <Icon className="infoicon" name={infoSVG} size="20px" /></h5>} >
                        <p>Select Forward/Supply if the sound source is emitting noise in the same direction to the airflow.</p>
                        <p>Select Return/Intake if the sound source is emitting noise in the opposite direction to the airflow.</p>
                    </Popup>
                <Select className='direction'
                        key='direction'
                        name="direction"
                        options={ direction }
                        onChange={ (item) => this.handleSelectChange('direction', item) }
                        defaultValue={ this.select_lookup(direction, 'direction') }
                        menuPlacement="auto"
                  />
                </div>
                <div className="select_box three">
                    <Popup 
                        trigger={<h5 className="info">Inlet and Outlet Conditions <Icon className="infoicon" name={infoSVG} size="20px" /></h5>} >
                        <p>These impact the installed pressure losses experienced by the silencer.
                            Select the most representative conditions to get the best possible pressure loss estimate.</p>
                    </Popup>
                <Select className='inlet_condition'
                        key='inlet_condition'
                        name="inlet_condition"
                        options={ inlet_condition }
                        onChange={ (item) => this.handleSelectChange('inlet_condition', item) }
                        defaultValue={ this.select_lookup(inlet_condition, 'inlet_condition') }
                        menuPlacement="auto"
                  />
                <Select className='outlet_condition'
                        key='outlet_condition'
                        name="outlet_condition"
                        options={ outlet_condition }
                        onChange={ (item) => this.handleSelectChange('outlet_condition', item) }
                        defaultValue={ this.select_lookup(outlet_condition, 'outlet_condition') }
                        menuPlacement="auto"
                  />
                </div>

                { (this.props.performance.performance === 'insertion') ? (
                    this.frequencies('Insertion Loss', 'insertion', delay)
                   ) : (
                        this.frequencies('Unsilenced Sound Levels', 'unsilenced', delay)
                   )}
            </form>
        );
    }
}

function ShowCalculationNew({ performance, item, selection, setSelection, isEditMode, setLoading, loading }) {
    const searchParams = new URLSearchParams(document.location.search)
    const dispatch = useDispatch();
    const item_id = item['@id'];
    const [silencer_default, setSilencerDefault] = useState({});
    const [silencer_model, setSilencerModel] = useState({});
    const [variant, setVariant] = useState();
    const [table, setTable] = useState({});
    const [calculator, setCalculator] = useState();
    if (searchParams.get('debug') ) {
        console.log('ShowCalculationNew', performance, calculator, "itemid", item_id, variant, table);
    }

    const [selected, setSelected] = useState();
    const silencer_variant = useSelector(state => state.silencer?.result);

    const [silencer_id, setSilencerId] = useState(item_id);
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        setLoading((prev) =>  prev + 1);
        const prefs = { ...performance,
                   type: "silencer_variant",
                   uids: [],
                   silencer_id: silencer_id,
                   debug: searchParams.get('debug'),
                   new_calculator: true}
        dispatch(
            getSilencer(silencer_id, prefs));
    }, [dispatch, performance]);

    useEffect(() => {
        if (silencer_variant?.silencer?.silencer_id === silencer_id){
            setLoading((prev) => {
                if (prev == 0) return prev;
                return prev - 1;
            });
            /* Reset table when there are errors or no data is returned due to non geometry constraints */
            if (silencer_variant?.silencer?.calculator?.errors || silencer_variant?.silencer?.table.length == 0){
                setTable({});
            }
            setSilencerModel({...silencer_variant});
            setSilencerDefault({...silencer_variant?.silencer?.models.filter(item => (item?.checked))[0]});
            /* Use default checked model from updated list if selected model is not included */
            setSelected((prev) => {
                    if (silencer_variant?.silencer?.models.filter(item => (item?.value == prev?.variant?.value)).length == 0){
                        return {['variant']: silencer_variant?.silencer?.models.filter(item => (item?.checked))[0]};
                    } else {
                        return prev
                    }
            });
        }
    }, [silencer_variant]);

    function updateUserNumber({option, item}){
        setVariant({'variant' : {...silencer_model?.selected_variant['variant']},
                    ...variant,
                    [option]: item});
    }
    
    function user_field(field){
        if ((table?.flow_dimensions || []).includes(field)){
            return 'user_' + field;
        } else {
            return field;
        }
    }
    useEffect(() => {
        /* use selected if is set otherwise use the default from the backend */
        if (selected?.variant?.value !== undefined ){
            setSilencerDefault(selected?.variant);
            setTable(...silencer_model?.silencer?.table.filter(item => (
                        item['@id'] == selected?.variant?.value)));
        } else if (silencer_model?.silencer?.checked?.variation !== undefined){
            setTable(...silencer_model?.silencer?.table.filter(item => (
                        item['@id'] == silencer_model?.silencer?.checked?.variation)));
        }
    }, [selected, silencer_model])
    

    return (
            <>
                <div className="select_options">
                { (silencer_model?.silencer?.models?.length ) ? (
                    <Select className={'variant'}
                            key={'variant'}
                            name={ 'variant' }
                            options={ silencer_model?.silencer?.models }
                            value={ {...silencer_default} }
                            onChange={ (item) => setSelected({['variant']: item})}
                            menuPlacement="auto"
                    /> ):(
                    <h3 className={'variant'} >{ table?.model || '' }</h3>
                    )
                    }
                </div>
                { (silencer_model?.silencer?.calculator?.errors || table?.performance || table?.checked) ? (
                <>
                <h4 className="performance table">Performance Table</h4>
                <div className="top-list listing-performance">
                    <table className="listing performance">
                        <tbody>
                        <VariantTable item={(table?.performance || table?.checked) ? table : silencer_model?.silencer} /> 
                        </tbody>
                    </table>
                </div>
                <Acoustic calculator={table} highlight={silencer_model?.silencer?.acoustic_max} />
                </>
                ):(
                <>
                <h4 className="performance">No model selection found at these requirements</h4>
                <p>Consider increasing Length, increasing Pressure Drop, decreasing Insertion Loss requirements,
                    or selecting Extended Casing instead of Standard.</p>
                <p>If you continue to have issues please contact your local Holyoake Branch where we will be happy to assist.</p>
                </>
                )}
                <RelatedItems related={ silencer_model?.related } />
                <div className="top-list listing-button">
                    { table?.performance && (
                    <>
                    <AddSelection selection={ selection } setSelection={ setSelection } calculator={ calculator } model={ item?.title } variant={variant} table={table} item={item} />
                    <ConditionalLink key={item.UID} className="ui button add blue notanon" title="Edit"
                        condition={!isEditMode} href={flattenToAppURL(item['@id'] + '/edit')}>Edit</ConditionalLink>
                    <GeneratePdfForm item={ item } calculator={ calculator } performance={ performance } table={table} selection={selection} setSelection={setSelection} />
                    <ShowMultiSilencer item={ item } calculator={ silencer_model?.silencer } variant={ table } />
                    </> )}
                    <ShowMore item={ item } calculator={ silencer_model?.silencer } />
                </div>
            </>
        )
}    


function AddSelection({selection, setSelection, calculator, model, variant, table, item}) {
    const fields = ['nominal_size',
                    'length', 
                    'direction',
                    'inlet_leg',
                    'outlet_leg',
                    'flow_rate',
                    'pressure_drop',
                    'installed_pressure_drop',
                    'module_width',
                    'number_of_components',
                    'number_of_modules',
                    'free_area_pc',
                    'pressure',
                    'weight',
                    ];
    const searchParams = new URLSearchParams(document.location.search)
    const attributes = table?.flow_option?.type || table?.description || '';
    function addToSelection() {
        toast.success(
      <Toast
        success
        title={"This item has been added to your selection list"}
        content=""
      />,
    );
    
    trackEvent({category: 'selection', action: "add", name: (table?.title || model)});
    const submittal = {path: item['@id'],
                       description: item?.description,
                       ...table?.submittal
                        }
    setSelection({...selection,
                  items:{...selection?.items,
                         'silencer':[...selection?.items?.silencer,
             {id: selection?.items?.silencer.length + 1,
              uuid: uuid(),
              submittal: submittal,
              amount: 1,
              reference: '',
              model: table?.title || variant?.title ,
              attributes:  attributes,
              nominal_size: calculator?.calculator?.nominal_size,
              sections: calculator?.calculator?.sections,
              ...rec,
             }]}})
    }
    if (searchParams.get('debug')){
        console.log("Add Selection", selection, "calc", calculator, model, variant, table);
    }
    let rec = {};
    for (const line of table?.performance || []) {
         if (fields.includes(line?.['field_name'])){
             rec[line['field_name']] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Nominal (w x h)'){
             rec['nominal_size'] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Nominal Diameter'){
             rec['nominal_size'] = 'Diameter ' + line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Overall (w x h)'){
             rec['overall_size'] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Overall Diameter'){
             rec['overall_size'] = 'Diameter ' + line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Component (w x h)'){
             rec['component_size'] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Length'){
             rec['length'] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Overall Diameter'){
             rec['overall_size'] = 'Diameter ' + line['value'] + ' ' + (line['units'] || '');
         }
    }
    for (const line of table?.selection_options || []) {
         if (fields.includes(line?.['field_name'])){
             rec[line['field_name']] = line['value'] + ' ' + (line['units'] || '');
         }
         if (line?.['field_name'] === 'Component (w x h)'){
             rec['component_size'] = line['value'] + ' ' + (line['units'] || '');
         }
    }
    for (const freq of AcousticFrequencies({ acoustic: undefined })){
        rec['insertion_loss_' + freq] = table?.acoustic?.items[0][freq];
    }
    for (const freq of AcousticFrequencies({ acoustic: undefined })){
        rec['generated_noise_' + freq] = table?.acoustic?.items[1][freq];
    }


    rec['notes'] = table?.notes || '';
    rec['acoustic'] = {'acoustic_max': {...table?.submittal?.acoustic_max},
                       'acoustic_insertion': {...table?.submittal?.acoustic_insertion}};

    return (
            <Button className="ui button add orange" title="Add item to selection" onClick={ addToSelection }>+</Button>
    )
}

function Spinner({loading}){
    return (
        <div className="spin-container">
            <div className="spin" id="loader"></div>
            <div className="spin" id="loader2"></div>
            <div className="spin" id="loader3"></div>
            <div className="spin" id="loader4"></div>
            <div id="text">Loading&nbsp;({loading})...</div>
        </div>
    )
}

function spinner_timer({loading}){
    const dispatchSpinner = useDispatch();

    useEffect(() => {
      let timer;
      if (loading) {
        timer = setTimeout(() => {
          dispatchSpinner({ type: "ui/showSpinner" });
        }, 100);
      } else {
        dispatchSpinner({ type: "ui/hideSpinner" });
      }               

      return () => clearTimeout(timer);
    }, [loading, dispatchSpinner]);
}  

function useDelayedSpinner(isLoading, delay = 500) {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    let timer;

    if (isLoading) {
      timer = setTimeout(() => setShowSpinner(true), delay);
    } else {
      setShowSpinner(false);
    }

    return () => clearTimeout(timer);
  }, [isLoading, delay]);

  return showSpinner;
}

const SilencerTemplate = ({ items, linkTitle, linkHref, isEditMode, popup }) => {
    const searchParams = new URLSearchParams(document.location.search)
    let link = null;
    let href = linkHref?.[0]?.['@id'] || '';
    if (isInternalURL(href)) {
        link = (
            <ConditionalLink className="ui raised segments modal" to={flattenToAppURL(href)} condition={!isEditMode}>
            {linkTitle || href}
            </ConditionalLink>
        );
    } else if (href) {
        link = <a className="ui raised segments modal" href={href}>{linkTitle || href}</a>;
    }
    const token = useSelector((state) => state.userSession.token, shallowEqual);

    const frequencies = AcousticFrequencies({ acoustic: undefined });
    const geometries = {'rectangular': ['width', 'height', 'length'],
                        'elbow': ['width', 'height', 'length', 'inlet_leg'],
                        'circular': ['diameter', 'length'],
    };

    const [performance, setPerformance] = useSessionStorage(
        'silencer_performance',
        Object.assign({protection: '',
                      casing: 'STD',
                      performance: 'insertion',
                      criteria: 'NC',
                      direction: 'F',
                      inlet_condition: 'I',
                      outlet_condition: 'I'},
                      ...(['airflow', 'pressure', 'target',
                           ...Object.entries(geometries).flatMap(([key, values]) => values.map(value => key + '_' + value)),
                           ...frequencies.map(frequency => 'insertion_'+frequency),
                           ...frequencies.map(frequency => 'unsilenced_'+frequency),
                           ]).map(dimension => {return ({[dimension]: undefined})})

        )
    );
    const [selection, setSelection] = SelectionStorage();

    const dispatch = useDispatch();
    const uids = items.map(item => item.UID);

    const prefs = { ...performance,
                   type: "silencer",
                   uids: uids,
                   new_calculator: true,
                   debug: searchParams.get('debug')}
    const location = useLocation();

    const delay = 500;
    const [loading, setLoading] = useState(0);
    spinner_timer({loading: loading});
    const showSpinner = useDelayedSpinner(loading, delay);
    
    const [spinner, setSpinner] = useState(null);

    useEffect(() => {
        if (spinner != null){
            clearTimeout(spinner);
        }
        if (loading > 0){
            setSpinner(setTimeout(() => setLoading(0) , 15000));
        }
    }, [loading]);

    if (searchParams.get('debug')) {
        console.log("Template", performance);
    }
  
    return (
        <>
            { showSpinner && <Spinner loading={loading} /> }

            <NameForm performance={ performance } setPerformance={ setPerformance } frequencies={ frequencies } geometries={ geometries } />
            <SelectionTable selection={ selection } setSelection={ setSelection } />
            <div className="items summaryplus modals active visible dimmable dimmed">
                {items.map((item) => (
                    <div className="ui listing-body left three item-list" key={item['@id']}>
                        <div className="top-list listing-image">
                            <img className="PreviewImage" src={flattenToAppURL(`${item['@id']}/@@images/${item.image_field}/preview`,)} alt={item.title || item.id} />
                        </div>
                        <div className="top-list listing-contents">
                             {token? (<a href={flattenToAppURL(item['@id'])}><h2 className="orange text heading underline">{item.title || item.id}</h2></a> ): (
                            <h2 className="blue text heading">{item.title || item.id}</h2> ) }
                            <h3 className="product desc blue text">{item.description}</h3>
                        </div>
                        <ShowCalculationNew 
                            performance={ performance }
                            item={ item }
                            selection={ selection}
                            setSelection={setSelection}
                            isEditMode={isEditMode}
                            setLoading={setLoading}
                            loading={loading} />
                        </div>
                ))}
            </div>
            {link && <div className="footer">{link}</div>}
        </>
    );
};

SilencerTemplate.propTypes = {
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
    linkMore: PropTypes.any,
    isEditMode: PropTypes.bool,
};

export default SilencerTemplate;
